<template>
  <v-container fluid grid-list-xl>
    <v-form
      ref="form"
      lazy-validation
    >
      <v-layout row wrap>
        <v-flex grow>
          <v-text-field
            label="DBA"
            v-model="filter.dba"
            box
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex>
          <v-menu
            ref="startDateModal"
            :close-on-content-click="false"
            v-model="startDateModal"
            :nudge-right="40"
            :return-value.sync="filter.start_date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="formattedStartDate"
              label="Created Start"
              append-icon="event"
              box
              hide-details
            ></v-text-field>
            <v-date-picker
              v-model="filter.start_date"
              no-title
              @input="$refs.startDateModal.save(filter.start_date)"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex>
          <v-menu
            ref="endDateModal"
            :close-on-content-click="false"
            v-model="endDateModal"
            :nudge-right="40"
            :return-value.sync="filter.end_date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="formattedEndDate"
              label="Created End"
              append-icon="event"
              box
              hide-details
            ></v-text-field>
            <v-date-picker
              v-model="filter.end_date"
              no-title
              @input="$refs.endDateModal.save(filter.end_date)"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex shrink>
          <v-btn color="primary" @click="search">Search</v-btn>
        </v-flex>
      </v-layout>

      <v-divider class="primary"></v-divider>
    </v-form>
    <table v-if="Object.keys(merchants).length > 0" class="v-datatable v-table theme--light">
      <thead>
        <tr>
          <th class="font-weight-bold text-xs-left column pa-1 ma-0 desc">DBA</th>
          <th class="font-weight-bold text-xs-center column pa-1 ma-0 desc">Transcenter ID</th>
          <th class="font-weight-bold text-xs-center column pa-1 ma-0 desc">Boarding Status</th>
          <th class="font-weight-bold text-xs-center column pa-1 ma-0 desc">Status</th>
          <th class="font-weight-bold text-xs-center column pa-1 ma-0 desc">TIDs</th>
          <th class="font-weight-bold text-xs-right column pa-1 ma-0 desc">View/Select Merchant Options</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in fpg" :key="account.account.TranscenterId">
          <td class="pa-1 ma-0 font-weight-bold">{{account.account.DBA}}</td>
          <td class="pa-1 ma-0 text-xs-center">{{account.account.TranscenterId}}</td>
          <td :class="['pa-1 ma-0 text-xs-center', `${account.match ? 'faps-merchant-boarded' : 'faps-merchant-not-boarded'}`]"><v-icon small class="mr-1">{{account.match ? 'fa-check' : ''}}</v-icon>{{account.match ? 'Boarded' : 'Not Boarded'}}</td>
          <td :class="['pa-1 ma-0 text-xs-center', `${account.match ? 'faps-merchant-boarded' : 'faps-merchant-not-boarded'}`]">{{account.details[0].MerchantStatus}}</td>
          <td class="pa-1 ma-0 text-xs-center">{{account.details[0].MidTids.length}}</td>
          <td class="ma-0 pa-0 text-xs-right">
            <v-btn @click="selectAccount(account); detailsModal = true" small ref="test">{{account.match ? 'View Options': 'Select Options'}}</v-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <v-dialog width="900" light v-if="merchantSelected" v-model="detailsModal" @keydown.esc.prevent="detailsModal = closeDetailsModal()">
      <v-toolbar dense>
        <v-toolbar-title>
          <h2 class="text-title">{{merchantSelected.account.DBA}}</h2>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="closeDetailsModal()">
          <v-icon>fa-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <template v-if="merchantSelected.details.length > 1">
                More than one merchant account for this account
              </template>
              <div class="d-flex">
                <div>
                  <h3 class="title">Merchant Details</h3>
                  <ul class="mt-3">
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Transcenter ID:</span>{{merchantSelected.details[0].TranscenterId}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Gateway Id:</span>{{merchantSelected.details[0].GatewayId}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Merchant Status:</span>{{merchantSelected.details[0].MerchantStatus}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Contact Name:</span>{{merchantSelected.details[0].ContactName}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Phone:</span>{{merchantSelected.details[0].PhoneNumber}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Email:</span>{{merchantSelected.details[0].Email}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Street:</span>{{merchantSelected.details[0].Street1}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">Street 2:</span>{{merchantSelected.details[0].Street2}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">City:</span>{{merchantSelected.details[0].City}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">State:</span>{{merchantSelected.details[0].State}}</p>
                    </li>
                    <li>
                      <p class="mb-0"><span class="font-weight-black mr-2">ZipCode:</span>{{merchantSelected.details[0].ZipCode}}</p>
                    </li>
                  </ul>
                </div>
              <div v-if="merchantSelected.match === false && terminalsCardCanCharge.length > 1">
                <h3 class="title">Merchant Boarding Options:</h3>
                <p class="text-caption font-italic font-weight-light">(Options locked to default for v1)</p>
                <h4>Fees and Options:</h4>
                <v-flex>
                  <div>
                    <v-container>
                      <v-layout row>
                        <v-flex>
                          <v-checkbox disabled dense v-model="canWaiveFees" label="Can Waive Fees" />
                        </v-flex>
                        <v-flex>
                          <v-checkbox disabled dense v-model="canWaiveInsuranceFees" label="Can Waive Insurance Fees" />
                        </v-flex>
                        <v-flex>
                          <v-checkbox disabled class="mr-5" dense v-model="hasCashDiscount" label="Cash Discount" />
                        </v-flex>

                      </v-layout>

                    </v-container>
                    <div class="d-flex">
                      <v-select
                        label="Fee Amount (Required)"
                        v-model="getCashDiscountAmount"
                        :items="getFeeSchedule"
                        item-text="name"
                        item-value="terminal_id"

                        outline
                        hide-details
                        :rules="amountRules"
                        :required="hasCashDiscount"
                      />
                    </div>
                    <div class="d-flex mt-3">
                      <v-select
                        :items="salesReps"
                        label="Sales Rep (Required)"
                        item-text="name"
                        item-value="id"
                        :rules="salesRepRules"
                        hint="Please Select a Sales Rep"
                        persistent-hint
                        required
                        outline
                        clearable
                        v-model="selectedSalesRep"
                      />
                    </div>
                    <div class="d-flex">
                      <v-checkbox disabled class="mr-5" dense v-model="hasAdminUser" label="Blue Yonder Admin User" />
                      <v-text-field
                        label="Blue Yonder Admin Email"
                        v-model="getAdminUserEmail"
                        disabled
                        outline
                        :required="hasAdminUser"
                        hide-details
                      />
                    </div>
                   </div>
                  </v-flex>
                  <div class="fixed right">
                    <v-btn color="primary" @click="confirmAddMerchant(merchantSelected.details[0].TranscenterId)" :disabled="!selectedSalesRep || !getCashDiscountAmount">
                      Add Merchant Options
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-divider class="my-3"></v-divider>
              <template>
                <div>
                  <thead>
                    <h3 class="text-h2">Processing Information</h3>
                  </thead>
                  <tbody>
                    <tr>
                    <th class="text-left">Description</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">MID</th>
                    <th class="text-left">TID</th>
                    <th class="text-left">Processor ID</th>
                    <th class="text-left">Live Date</th>
                    <th class="text-left">Match</th>
                    <th></th>
                  </tr>
                  <tr v-for="tid in merchantSelected.details[0].MidTids" :key="tid.MID">
                    <td class="px-1 font-wieght-bold">{{tid.AccountType.toUpperCase()}}</td>
                    <td class="px-1">{{tid.Status}}</td>
                    <td class="px-1">{{tid.MID}}</td>
                    <td class="px-1">{{tid.TID}}</td>
                    <td class="px-1 text-center">{{tid.ProcessorId}}</td>
                    <td class="px-1 text-center">{{tid.Description}}</td>
                    <td class="px-1">{{tid.LiveDate}}</td>
                    <td class="px-1">{{tid.match}}</td>
                    <td class="px-1">
                      <v-btn color="primary" v-if="tid.match && tid.Status === 'Enabled' && tid.AccountType.includes('ach')" @click="addAchCategories(merchantSelected.details[0].TranscenterId)">Re-Add Categories</v-btn>
                    </td>
                  </tr>
                  </tbody>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

    </v-dialog>

  </v-container>
</template>

<script>
import JsonExcel from 'vue-json-excel'
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, StoreMixin, UtilityMixin],

  components: {JsonExcel},

  data: function () {
    return {
      startDateModal: false,
      endDateModal: false,

      fpg: [],
      merchants: [],
      fpg_accounts: [],
      detailsModal: false,
      merchantSelected: null,
      salesReps: [],
      selectedSalesRep: null,

      canWaiveFees: true,
      canWaiveInsuranceFees: true,

      hasCashDiscount: true,
      cashDiscountAmount: '',

      hasAdminUser: true,
      adminUserEmail: '',
      adminUserEmailRules: {
        counter: value => value.length <= 40 || 'Max 40 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },

      filter: {
        dba: '',
        start_date: '',
        end_date: ''
      },
      salesRepRules: [
        (v) => !!v || 'Sales Rep is required'
      ],
      amountRules: [
        (v) => !!v || 'Amount is required'
      ]
    }
  },

  created () {
    if (!this.hasPermission('superuser')) {
      this.$store.commit('error', 'Access Denied')
      this.$router.go(-1)
    }
  },

  async mounted () {
    const salesReps = await this.getAccountSalesReps()
    this.salesReps = salesReps.data.rows
  },

  computed: {
    formattedStartDate () {
      return this.filter.start_date ? Moment(this.filter.start_date).format('MMM-DD-YYYY') : ''
    },
    formattedEndDate () {
      return this.filter.end_date ? Moment(this.filter.end_date).format('MMM-DD-YYYY') : ''
    },
    getAdminUserEmail: {
      get () {
        return this.adminUserEmail || `admin+${this.sanitizeMerchantToEmailName(this.merchantSelected.account.DBA.split(' ').join('').toLowerCase())}@blueyondercorp.com`
      },
      set (value) {
        this.adminUserEmail = value
      }
    },
    getCashDiscountAmount: {
      get () {
        return this.cashDiscountAmount || 'blueyonder395'
      },
      set (value) {
        this.cashDiscountAmount = value
      }
    },
    getFeeSchedule () {
      return Object.keys(this.feeSchedule)
    }
  },

  methods: {
    selectAccount (account) {
      this.merchantSelected = account
    },

    async getAccountSalesReps () {
      let result = await this.api({
        method: 'get',
        url: '/users',
        params: {
          filter: {
            position: 'Account Rep'
          }
        }
      })
      return result
    },

    closeDetailsModal () {
      this.detailsModal = false
      this.cashDiscountAmount = ''
    },

    async search (id) {
      Bus.$emit('openWaitModal')

      try {
        let filter = { ...this.filter }

        let result = await this.api({
          method: 'get',
          url: '/fpg_accounts',
          params: {
            filter: filter
          }
        })

        if (result.data.filter) {
          if (result.data.filter.startDate && result.data.filter.startDate !== filter.start_date) {
            this.filter.start_date = result.data.filter.startDate
          }
          if (result.data.filter.endDate && result.data.filter.endDate !== filter.end_date) {
            this.filter.end_date = result.data.filter.endDate
          }
        }

        if (result.data.accounts) {
          this.fpg = result.data.fpg
          this.merchants = result.data.accounts
          this.fpg_accounts = result.data.fpg_accounts

          for (let account of this.fpg) {
            let accountMatch = this.fpg_accounts.find(obj => {
              return obj.merchant_id === account.account.TranscenterId
            })
            if (accountMatch) {
              account.match = true
            } else {
              account.match = false
            }

            for (let tid of account.details[0].MidTids) {
              let tidMatch = this.fpg_accounts.find(obj => {
                return obj.processor_id === tid.ProcessorId
              })
              if (tidMatch) {
                tid.match = true
              } else {
                tid.match = false
              }
            }
          }
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    async addMerchant (id) {
      try {
        Bus.$emit('openWaitModal')
        let response = await this.api({
          method: 'get',
          url: `/fpg_accounts/${id}/board`,
          params: {
            // Permissions
            'can_use_virtual_terminal': true,
            'can_view_transactions': true,
            'can_manage_transactions': true,
            'can_view_account_transactions': true,
            'can_manage_account_transactions': true,
            'can_view_schedules': true,
            'can_manage_schedules': true,
            'can_view_account_schedules': true,
            'can_manage_account_schedules': true,
            'has_recurring_options': true,
            'has_installment_options': true,
            'can_use_hpp': true,
            'has_inline_help': true,
            'can_waive_card_fees': this.canWaiveFees,
            'can_waive_health_card_fees': this.canWaiveInsuranceFees,
            'cash_discount': this.getCashDiscountAmount,
            'admin_user': this.getAdminUserEmail,
            'sales_rep': this.selectedSalesRep,
            // Custom
            'rows_per_page': '10',
            'customer_name': true,
            'request_type': true,
            'transaction_status': true,
            'transactions_source_id': true,
            'last_four': true,
            'card_expiration_yymm': true,
            'total_amount': true,
            'less_fee_amount': true,
            'is_recurring': true,
            'created': true,
            'settled': true,
            'customer_po': true,
            'custom_field_1': true,
            'custom_field_2': true,
            'custom_field_3': true
          }
        })

        for (let [index, account] of this.fpg.entries()) {
          if (account.account.TranscenterId === id) {
            account.match = true
            for (let tid of account.details[0].MidTids) {
              tid.match = true
            }
            this.$set(this.fpg, index, account)
          }
        }

        if (response.data.data.accounts[0]) {
          if (response.data.data.accounts[0]['warning']) {
            Bus.$emit('openModal', {
              status: 'info',
              message: 'Merchants Boarded Successfully with Warnings:',
              messageDetails: [
                `ID: ${response.data.data.accounts[0].id}` || 'N/A',
                `DBA: ${response.data.data.accounts[0].dba}` || 'N/A',
                `Sales Rep: ${response.data.data.accounts[0]['sales_rep'] ? response.data.data.accounts[0]['sales_rep'] : 'No Rep assigned'} ` || 'Bill Catlett',
                `Contact: ${response.data.data.accounts[0].contact}` || 'N/A',
                `Email: ${response.data.data.accounts[0].email}` || 'N/A',
                `Password: ${response.data.data.accounts[0].password}` || 'N/A',
                `Admin Email: ${response.data.data.accounts[0]['admin_user']}` || 'N/A',
                `Admin Password: ${response.data.data.accounts[0]['admin_password']}` || 'N/A',
                `Warning: ${response.data.data.accounts[0]['warning']}`
              ]
            })
          } else {
            Bus.$emit('openModal', {
              status: 'success',
              message: 'Merchant Boarded Successfully',
              messageDetails: [
                `ID: ${response.data.data.accounts[0].id}` || 'N/A',
                `DBA: ${response.data.data.accounts[0].dba}` || 'N/A',
                `Sales Rep: ${response.data.data.accounts[0]['sales_rep'] ? response.data.data.accounts[0]['sales_rep'] : 'No Rep assigned'} ` || 'Bill Catlett',
                `Contact: ${response.data.data.accounts[0].contact}` || 'N/A',
                `Email: ${response.data.data.accounts[0].email}` || 'N/A',
                `Password: ${response.data.data.accounts[0].password}` || 'N/A',
                `Admin Email: ${response.data.data.accounts[0]['admin_user']}` || 'N/A',
                `Admin Password: ${response.data.data.accounts[0]['admin_password']}` || 'N/A'
              ],
              persist: true
            })
          }
        } else {
          Bus.$emit('openModal', {
            status: 'error',
            message: 'Unknown problem with boarding'
          })
        }
        this.addAchCategories(id)
      } catch (error) {
        Bus.$emit('openModal', {
          status: 'error',
          message: error
        })
      } finally {
        Bus.$emit('closeWaitModal')
        this.cashDiscountAmount = ''
      }
    },

    confirmAddMerchant (id) {
      const processingInformation = this.merchantSelected.details[0].MidTids
      let ach = 0
      let retail = 0
      for (let index = 0; index < processingInformation.length; index++) {
        if (processingInformation[index].AccountType === 'ach') {
          ach = ach + 1
        }
        if (processingInformation[index].AccountType === 'retail') {
          retail = retail + 1
        }
      }
      if (window.confirm(`Are you sure you want to add this Merchant? ${ach !== 1 ? `\nMerchant has ${ach} Ach Account(s)` : ''} ${retail !== 1 ? `\nMerchant has ${retail} Retail Account(s)` : ''}`)) {
        this.addMerchant(id)
      }
    },

    async addTid (id) {
      try {
        Bus.$emit('openWaitModal')
        await this.api({
          method: 'get',
          url: '/transactions',
          params: {
          }
        })
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    async addAchCategories (id) {
      try {
        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'get',
          url: `/fpg_tids/${id}/create_ach_categories`,
          params: {
          }
        })

        if (result.data.error) {
          Bus.$emit('openModal', {
            status: 'error',
            message: 'Problem with adding some or all ACH categories',
            messageDetails: result.data.data.map(error => {
              if (error.error) {
                return error.type + ': ' + error.error
              }
            })
          })
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>

<style>
  .faps-merchant-boarded {
    background-color: var(--v-success-lighten4);
    color: var(--v-success-darken4);
    text-transform: uppercase;
    font-weight: bold !important;
  }

  .faps-merchant-not-boarded {
    background-color: var(--v-error-lighten5);
    color: var(--v-error-darken4);
    text-transform: uppercase;
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/fpg/Merchants.vue